import { render, staticRenderFns } from "./game_center.vue?vue&type=template&id=3ee6534b"
import script from "./game_center.vue?vue&type=script&lang=js"
export * from "./game_center.vue?vue&type=script&lang=js"
import style0 from "./game_center.vue?vue&type=style&index=0&id=3ee6534b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports